<template>
  <div class="interaction-body answered fill-in-the-blank fill-in-the-blank-answered">
    <div
      class="playposit-answer mt-2 mb-1 py-1 pr-1"
      :class="interactionOptionData[idx].answerClass"
      :key="io.id"
      v-for="(io, idx) in localInteraction.interactionOptions"
    >
      <text-box
        :color-key="interactionOptionData[idx].textBoxColorKey"
        :show-color-rod="!hideCorrectAnswerAlways"
        :title="interactionOptionData[idx].textBoxTitle"
        :show-title="interactionOptionData[idx].showTextBoxTitle"
        :subtitle="`Blank ${idx + 1} - `"
        :subtitle-chips="io.option.split(delimiter)"
        :text="io.feedback"
        :indent="false"
        title-classes="mb-1"
        tabindex="0"
        :aria-label="interactionOptionData[idx].ariaLabel"
        :attachments="io.interactionOptionFeedbackAttachments"
        :add-extra-space-above="true"
      ></text-box>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import TextBox from '../../Snippets/TextBox.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'FillInTheBlankAnsweredInteractionBody',
  components: {
    TextBox,
  },
  mixins: [
    Interaction,
  ],
  props: {
    interactionAttempt: {
      type: Object,
      required: true,
    },
  },
  computed: {
    selectedAnswers() {
      if (!_.get(this, 'localInteractionAttempt.responseText')) return [];
      return _.get(this, 'localInteractionAttempt.responseText', '').split(this.delimiter);
    },
    interactionOptionData() {
      return this.localInteraction.interactionOptions.map((io, idx) => {
        const answerArray = io.option
          .split(this.delimiter)
          .map((option) => option.toLowerCase().trim());
        const isCorrect = answerArray.includes(_.get(this, `selectedAnswers[${idx}]`, '').toLowerCase().trim());
        let textBoxTitle;
        if (this.hideCorrectAnswerAlways) textBoxTitle = 'Feedback';
        else textBoxTitle = isCorrect ? 'Correct' : 'Incorrect';
        return {
          answerClass: (() => {
            if (this.hideCorrectAnswerAlways) return '';
            return isCorrect ? 'correct' : 'incorrect';
          })(),
          textBoxColorKey: (() => {
            if (this.hideCorrectAnswerAlways) return 'hidden';
            return isCorrect ? 'green' : 'red';
          })(),
          textBoxTitle,
          showTextBoxTitle: !this.hideCorrectAnswerAlways || io.feedback.length,
          ariaLabel: (() => {
            let label = `Answer #${idx + 1}. `;
            if (textBoxTitle !== 'Feedback') label += `Answer result: ${textBoxTitle}. `;
            const nonLastAnswers = answerArray.slice(0, -1).join(', ');
            label += `Expected answer: ${nonLastAnswers}${nonLastAnswers.length > 1 ? ',' : ''} or ${answerArray.slice(-1)}. `;
            label += `Provided answer: ${this.selectedAnswers[idx]}.`;
            return label;
          })(),
        };
      });
    },
  },
};
</script>
